module.exports = __webpack_public_path__ + "img/brand_bosch.12cbeb89.webp";